$(document).ready(function(){
	
	var fancyboxSettings = {
    margin: [100, 30],
    buttons : [
      'slideShow',
      'fullScreen',
      'thumbs',
      'close'
    ],
    idleTime: false,
	};

	$("[data-fancybox]").fancybox(fancyboxSettings);

});